export default __webpack_public_path__ + "static/media/visa.16f1c169.svg";